import config from '../config';

export const pictureUrl = state => {
    const pictures = state.widget.pictures.find(
        a =>
            a.recipientPictureIds.indexOf(
                state.widget.activeAction.recipientPictureIds[0]
            ) !== -1
    );
    return (pictures || {}).pictureUrls; //Note: This function has a misleading name. Either returns an array of strings or undefined.
};

export const getImageUrl = (logoId, source = 'CDN_URL') => {
    return logoId != null ? `${config[source]}${logoId}` : null;
};
